<template>
  <div v-if="response && !readnre" class="my-2">
    <span class="secondary">File </span>
    <b-badge variant="secondary" class="mx-2 py-1 px-2">{{
      response.name
    }}</b-badge>
    <span class="secondary">{{ $t('UploadComponent.uploadSuccess') }}</span>

    <span
      class="text-secondary point ml-1"
      v-if="!encr"
      role="button"
      tabindex="0"
      @click="refreshAll"
      @keydown.enter.prevent="refreshAll"
      @keydown.space.prevent="refreshAll"
      >{{ $t('UploadComponent.uploadNew') }}</span
    >
  </div>
  <div v-else-if="response && readnre" class="my-2">
    <span v-if="response.nre" class="secondary"
      >{{ $t('UploadComponent.codeDetected') }}
    </span>
    <span v-else class="text-danger"
      >{{ $t('UploadComponent.codeNotDetected') }}</span
    >
  </div>
  <div
    class="d-flex align-content-center justify-content-between flex-wrap my-2"
    v-else
  >
    <b-form-file
      v-model="form.file"
      :accept="acceptedFormats"
      ref="file-up"
      :placeholder="$t('UploadComponent.placeholder')"
      class="custom-file-input my-1 col-9 col-xl-10 px-0"
    ></b-form-file>
    <b-button
      v-if="dest !== 'immagine-progetto-blog'"
      @click="doUpload"
      :disabled="form.file == null"
      ref="caricaUploadButton"
      variant="secondary px-3 my-1"
    >
      <b-spinner v-if="uploading" :label="$t('caricamento')"></b-spinner>
      <span v-else> {{ $t('UploadComponent.upload') }} </span>
    </b-button>
    <p v-if="errorMessage" class="text-danger col-12 mb-0">
      {{ errorMessage }}
    </p>
  </div>
</template>
<script>
import { reservationService } from "@/_services"
export default {
  name: "UploadComponent",
  props: ["encr", "dest", "readnre", "accept"],
  computed: {
    acceptedFormats: function () {
      if (this.encr) return ".pdf,image/*"
      else if (this.dest == "profilo") return "image/*"
      else return this.accept || null
    }
  },
  data() {
    return {
      form: {
        file: null,
        destination: "order",
        name: null,
        has_owner: false,
        encrypt: false
      },
      response: null,
      uploading: false,
      errorMessage: null
    }
  },
  watch: {
    // form: {
    //   handler: function (newVal, oldVal) {
    //     if (newVal.file != null && this.dest == "profilo") {
    //       this.form.name = newVal.file.name
    //       this.$emit("show-carica-button", newVal.file)
    //     }
    //   },
    //   deep: true
    // },
    "form.file": function (newVal) {
      this.form.name = newVal.name
      if (this.dest == "profilo") {
        this.$emit("show-carica-button", newVal)
      } else if (this.dest == "immagine-progetto-blog") {
        this.doUpload()
      } else {
        this.doUpload()
      }
    }
  },
  methods: {
    click() {
      this.$refs["file-up"].$el.querySelector('input[type="file"]').click()
    },
    doUpload() {
      console.log()
      this.uploading = true
      var form = new FormData()
      // if (this.form.file) {
      form.append("file", this.form.file)
      form.append("name", this.form.name)
      // }
      form.append("destination", this.form.destination)
      form.append("has_owner", this.form.has_owner)
      form.append("encrypt", this.form.encrypt)
      if (this.readnre) {
        form.append("read_nre", true)
      }
      this.errorMessage = null
      const self = this
      reservationService
        .uploadFile(form)
        .then(function (res) {
          // console.log(res);
          if (self.dest != "profilo") {
            self.response = res.data.data
          }
          self.$emit("upload-result", res.data.data)
          self.uploading = false
        })
        .catch(function (err) {
          if (err.status && err.status === 422) {
            self.errorMessage = self.$t('UploadComponent.invalidFile')
          }
          console.log(err)
          self.uploading = false
        })
    },
    handleFile(e) {
      // console.log(this.file);
      // console.log(e.target.files);
    },
    refreshAll() {
      this.form.file = null
      this.form.destination = "order"
      if (this.dest) {
        this.form.destination = this.dest
      }
      this.form.name = null
      this.form.has_owner = false
      this.form.encrypt = false
      if (this.encr == true) {
        this.form.encrypt = this.encr
      }
      this.response = null
    }
  },
  created() {
    if (this.encr == true) {
      this.form.encrypt = this.encr
    }
    if (this.dest) {
      this.form.destination = this.dest
    }
  }
}
</script>
